export const colors = {
  socialMedia: {
    Bluesky: '#0085FF',
    X: '#312F2E',
    Line: '#22ba4f',
  },
  blue: {
    '50': '#F0F4FD',
    '100': '#D7E0F7',
    '200': '#AEC0EE',
    '300': '#90ABF1',
    '400': '#6084E2',
    'roche-600': '#0B41CD',
    '700': '#0936AB',
    '900': '#022366',
    '950': '#011745',
    // charts
    '01': '#0936ab',
    '02': '#0242c1',
    '03': '#0254d5',
    '04': '#0a68e1',
    '05': '#297bed',
    '06': '#3d90f1',
    '07': '#56a4f0',
    '08': '#75b6f0',
    '09': '#92c7f0',
    '10': '#b6d9f2',
  },
  white: {
    'base': '#FFFFFF',
    'transparent-10': 'rgba(255, 255, 255, 0.1)',
    'transparent-20': 'rgba(255, 255, 255, 0.2)',
    'transparent-30': 'rgba(255, 255, 255, 0.3)',
  },
  black: {
    'base': '#000000',
    'transparent-05': 'rgba(0, 0, 0, 0.05)',
    'transparent-10': 'rgba(0, 0, 0, 0.1)',
  },
  grey: {
    '50': '#FBFBFA',
    '100': '#F5F5F2',
    '200': '#EAE8E5',
    '300': '#DBD6D1',
    '400': '#C2BAB5',
    '500': '#9D948E',
    '600': '#706B69',
    '700': '#544F4F',
    '800': '#312F2E',
    '900': '#21201F',
  },
  neutral: {
    '100': '#FFF7F5',
    '200': '#FFE8DE',
    '300': '#FAD6C7',
    '400': '#FAC9B5',
    // charts
    '01': '#362a24',
    '02': '#4a3a32',
    '03': '#665045',
    '04': '#85685a',
    '05': '#a3806e',
    '06': '#c29883',
    '07': '#e0b098',
    '08': '#fad7c5',
    '09': '#fce8de',
    '10': '#fcf4f0',
  },
  yellow: {
    '200': '#FFF0C4',
    '500': '#E9B519',
  },
  green: {
    '200': '#CBEDE8',
    '500': '#006D5E',
    'conference': '#20c058',
    'congressAbstract': '#179543',
    // charts
    '01': '#00493c',
    '02': '#005a47',
    '03': '#066b55',
    '04': '#167c63',
    '05': '#118f70',
    '06': '#22a181',
    '07': '#45b197',
    '08': '#6bc0ad',
    '09': '#89cec2',
    '10': '#abded7',
  },
  purple: {
    '100': '#F2D4FF',
    '400': '#7D0096',
    // charts
    '01': '#6e0584',
    '02': '#82159e',
    '03': '#9522bd',
    '04': '#a831d9',
    '05': '#bb42f3',
    '06': '#ca5aff',
    '07': '#d579fe',
    '08': '#df93fd',
    '09': '#e1aff4',
    '10': '#e9caf3',
  },
  orange: {
    '100': '#FFBD69',
    '200': '#FF7D29',
    // charts
    '01': '#a11e01',
    '02': '#b83310',
    '03': '#d04618',
    '04': '#e35a1d',
    '05': '#f46e26',
    '06': '#fd8233',
    '07': '#fc9647',
    '08': '#fbaa5f',
    '09': '#f9bc7d',
    '10': '#f9cd98',
  },
  red: {
    '100': '#FF8782',
    '200': '#ff1f26',
    '300': '#C40000',
    '400': '#8C0000',
    // charts
    '01': '#850500',
    '02': '#a10907',
    '03': '#bb1611',
    '04': '#d22926',
    '05': '#e93b39',
    '06': '#fa544b',
    '07': '#fe765e',
    '08': '#fd9476',
    '09': '#ffac90',
    '10': '#fec9b3',
  },
  pink: {
    '01': '#480F31',
    '02': '#610F40',
    '03': '#7D1352',
    '04': '#AD2175',
    '05': '#CC3D92',
    '06': '#E557AC',
    '07': '#ED7EBF',
    '08': '#F29DD0',
    '09': '#FAC0E2',
    '10': '#F6D4ED',
  },
  brown: {
    ct: '#bb8377',
    enquiry: '#a66254',
  },
  chart: {
    'face-to-face': '#983EBB',
    'phone': '#87BDF7',
    'email-manual': '#F47D34',
    'messaging': '#DA7474',
    'whatsapp': '#25D366',
    'sms': '#DA7474',
    'message-manual': '#D44040',
    'remote-visit': '#1482FA',
    'fax': '#C0920A',
    'other': '#C6BCB7',
    'email-one-to-one': '#F0B70D',
    'email-one-to-many': '#DA7474',
    'event': '#32A6AE',
    'website': '#0B24CB',
  },
} as const;
